import { render, staticRenderFns } from "./JdsInput.vue?vue&type=template&id=047e29cd"
import script from "./JdsInput.vue?vue&type=script&lang=js"
export * from "./JdsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports